<template>
    <div class="site-header-mobile">
        <div class="row">
            <div class="col col-s6"><div id="side-title"><router-link to="/"><h1>DAP<div>studio</div></h1></router-link></div></div>

            <div class="col col-s6 btn-menu yo-align-right"><a href="#!" v-on:click.prevent="$teras.mobMmenu = !$teras.mobMmenu">
                <i class="material-icons" v-if="$teras.mobMmenu">close</i>
                <i class="material-icons" v-if="!$teras.mobMmenu">menu</i>
            </a></div>
        </div>
        <div class="row menu" v-if="$teras.mobMmenu">
            <div class="col col-s12">
            <el-menu default-active="1" :router="true" :unique-opened="true">

                <el-submenu index="contributi" class="">
                    <template slot="title">ABOUT US</template>
                    <el-menu-item index="/inside/profilo/studio" class="_page-team">profile</el-menu-item>
                    <el-menu-item index="/inside/profilo/team" class="_page-team">team</el-menu-item>
                    <el-menu-item index="/inside/profilo/clienti" class="_page-team">clients</el-menu-item>
                    <el-menu-item index="/inside/profilo/premi" class="_page-premi">awards</el-menu-item>
                    <el-menu-item index="/inside/profilo/mostre" class="_page-mostre">exhibitions</el-menu-item>
                    <el-menu-item index="/inside/profilo/pubblicazioni" class="_page-pubblicazioni">publications</el-menu-item>
                    <el-menu-item index="/inside/profilo/eventi" class="_page-eventi">events</el-menu-item>
                </el-submenu>

                <el-submenu index="comitati" class="">
                    <template slot="title">PROJECTS</template>
                    <el-menu-item index="/progetti" class="_page-selezione">selected</el-menu-item>

            <el-popover ref="temiPop" placement="left" width="140" trigger="hover" v-model="temiPopV">
                <router-link to="/tema/1/interiors" v-on:click.native="temiPopV = false">interiors</router-link>
                <router-link to="/tema/2/graftings" v-on:click.native="temiPopV = false">graftings</router-link>
                <router-link to="/tema/3/reuse" v-on:click.native="temiPopV = false">reuse</router-link>
                <router-link to="/tema/4/relational spaces" v-on:click.native="temiPopV = false">relational spaces</router-link>
                <router-link to="/tema/5/texture" v-on:click.native="temiPopV = false">texture</router-link>
                <router-link to="/tema/6/sustainability" v-on:click.native="temiPopV = false">sustainability</router-link>
                <router-link to="/tema/7/transformation" v-on:click.native="temiPopV = false">transformation</router-link>
            </el-popover>

            <li v-popover:temiPop class="el-menu-item vmenupop">topics</li>

            <el-popover ref="tipologiePop" placement="left" width="140" trigger="hover" offset="0" v-model="tipologiePopV">
                <router-link to="/tipologia/1/urban spaces and landscape" v-on:click.native="tipologiePopV = false">urban spaces and landscape</router-link>
                <router-link to="/tipologia/2/public buildings" v-on:click.native="tipologiePopV = false">public buildings</router-link>
                <router-link to="/tipologia/3/offices and commercial spaces" v-on:click.native="tipologiePopV = false">offices and commercial spaces</router-link>
                <router-link to="/tipologia/4/housing" v-on:click.native="tipologiePopV = false">housing</router-link>
                <router-link to="/tipologia/5/cultural projects" v-on:click.native="tipologiePopV = false">cultural projects</router-link>
            </el-popover>

            <li v-popover:tipologiePop class="el-menu-item vmenupop" >types</li>


                </el-submenu>

                <el-menu-item index="/inside/contatti/contatti" class="">CONTACTS</el-menu-item>  



            </el-menu>
            </div>
        


        <div class="nav-bottom yo-align-center" style="">

            <div class="nav-lang">
                <a href="/site">it</a>
                <router-link to="/">en</router-link>
                <router-link to="/inside/coming/coming">fr</router-link>
            </div>

            <!-- <router-link to="/inside/contatti/contatti" class="first _page-contatti" style="margin:4px 0 8px 0;display:block;">contatti</router-link> -->
            <router-link to="/inside/contatti/note_legali" class="first _page-contatti" style="margin:4px 0 8px 0;display:block;">legal notes</router-link>

            <div class="nav-social">
                <a target="_blank" href="https://twitter.com/dap_studio"><img src="../assets/twitter.svg" alt="Twitter icon"></a>
                <a target="_blank" href="https://www.facebook.com/pages/DAPstudio-elena-sacco-paolo-danelli/160426864008613"><img src="../assets/facebook.svg" alt="Facebook icon"></a>
                <a target="_blank" href="https://www.instagram.com/dapstudio"><img src="../assets/instagram.svg" alt="Instagram icon"></a>
            </div>

            

        </div>


        </div>

    </div>
</template>

<script>

export default {
  name: 'site-header-mobile',
  data() {
        return {
        tipologiePopV: false,
        temiPopV: false
        }   
    }
}
</script>
<style >
.site-header-mobile .el-tooltip{
    display:none !important;
}
.site-header-mobile{
    top:0;
    left:0;
    padding:15px;
    position:fixed;
    width: 100%;
    background:#ffffff;
}.site-header-mobile #side-title h1{
    margin:0;
    font-size:4.0rem;
    text-align:left;
}.site-header-mobile #side-title h1 div{
    margin:-5px 0 0 8px;
    font-size:1.6rem;
    letter-spacing: 7px;
}.site-header-mobile .btn-menu a i{
    line-height: 48px;
    font-size:4.0rem;
}.site-header-mobile .row.menu{
    margin-top:10px;
    /*
    padding-top:10px;
    
    border-top:1px solid #cccccc;
    */
    min-height:100vh;   
}.site-header-mobile .nav-lang{
    text-align:center;
    
}.site-header-mobile .nav-lang a {
    color:#353535;
    padding:0 5px;
}.site-header-mobile .nav-social{
    text-align:center;
    
}.site-header-mobile .nav-social a img{
    height: 15px;
    padding:0 5px;
}.site-header-mobile .nav-bottom{
    z-index: 1;
    position:fixed;
    padding: 0 0 30px 0;
    bottom:0;
    left:0;
    width: 100vw;
    color: #222222;






}.site-header-mobile .el-menu{
    z-index: 10;
 
    
}.site-header-mobile .el-submenu__title i{
    display:none;
}.site-header-mobile ul.el-menu,.site-header-mobile .el-submenu__title:hover,.site-header-mobile .el-menu-item:hover{
    background:#ffffff !important;
    text-align:center;
    
    
}.site-header-mobile .menu .el-submenu{
    background:#ffffff;
}.site-header-mobile .menu .el-menu-item,.site-header-mobile .el-submenu .el-submenu__title{
    border:1px solid #666666 !important;
    font-weight:700;
    color:#353535 !important;
    border-bottom:0  !important;
    background: #ffffff !important;
}.site-header-mobile .menu .el-menu-item:last-child,.site-header-mobile .el-submenu.is-opened .el-submenu__title{
    border:1px solid #666666 !important;

}.site-header-mobile .el-submenu .el-submenu__title{
    
}.site-header-mobile .el-submenu  .el-menu-item{
    border:0 !important;
    font-weight:400;
    border-bottom:1px solid #cccccc !important;
    margin:0 12% !important;
}.site-header-mobile .el-submenu  .el-menu-item:first-child  {
    margin:0 12%;
}.site-header-mobile  .el-submenu .el-menu-item{
     line-height:40px !important;
     height:40px !important;
}.site-header-mobile  .el-submenu .el-menu-item:last-child{
     border:0 !important;
}
</style>



// WEBPACK FOOTER //
// Header-mobile.vue?005f4067